import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"outlined":"","label":_vm.$t('Maximum total uses'),"hide-details":"auto","type":"number"},model:{value:(_vm.max_total_uses),callback:function ($$v) {_vm.max_total_uses=$$v},expression:"max_total_uses"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }